import React, { useState, useEffect, useContext } from 'react';
import { Stack, Autocomplete, Typography, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormMode, GenderList } from '../utils/extensions/constantEx';
import { GetDayJSValueFromUTCDate } from '../utils/extensions/functionEx';
import { HomeContext } from '../utils/contexts/homeContext';
import { NurseFormContext } from '../utils/contexts/nurseFormContext';
import NurseAddress from './nurseAddress'
import dayjs from 'dayjs';

const NursePersonalnfo = (props) => {

    const { formOpenMode, expanded, isShowValidationMsgs } = props;
    const { handleAccordionChange } = props;

    const { OpenErrorAlert, homeState } = useContext(HomeContext);
    const { nurseFormValue, selectedNurseJosn, SetNurseFormValue } = useContext(NurseFormContext);

    const [cleared, setCleared] = useState(false);
    const [dob, setDOB] = useState(null);
    const [age, setAge] = useState(0);
    const [selectedGender, setSelectedGender] = useState(GenderList[1]);
    const [spouseName, setSpouseName] = useState('');
    const [fatherName, setFatherName] = useState('');
    const [motherName, setMotherName] = useState('');
    const [policeStation, setPoliceStation] = useState('');
    const [education, setEducation] = useState('');
    const [languagesKnown, setLanguagesKnown] = useState('');
    const [height, setHeight] = useState('');
    const [colour, setColour] = useState('');
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [bankAccount, setBankAccount] = useState('');
    const [notes, setNotes] = useState('');
    const [aadhaar, setAadhaar] = useState('');
    const [isAadharDocForm, setIsAadharDocForm] = React.useState(false);
    const [aadharUploadedDoc, setAadharUploadedDoc] = React.useState(null);

    useEffect(() => {
        setDOB(null);
        setAge(0);
        setSelectedGender(GenderList[1]);
        setSpouseName('');
        setFatherName('');
        setMotherName('');
        setPoliceStation('');
        setEducation('');
        setLanguagesKnown('');
        setHeight('');
        setColour('');
        setSelectedReligion(null);
        setBankAccount('');
        setNotes('');
        setAadhaar('');
        setIsAadharDocForm(false);
        setAadharUploadedDoc(null);
    }, [formOpenMode]);

    useEffect(() => {
        if ((formOpenMode === FormMode.ViewMode || formOpenMode === FormMode.EditMode) && selectedNurseJosn && selectedNurseJosn.id > 0) {
            setSpouseName(selectedNurseJosn.spouse_name);
            setFatherName(selectedNurseJosn.father_name);
            setMotherName(selectedNurseJosn.mother_name);
            setPoliceStation(selectedNurseJosn.police_station);
            setEducation(selectedNurseJosn.education);
            setLanguagesKnown(selectedNurseJosn.police_station);
            setHeight(selectedNurseJosn.height > 0 ? selectedNurseJosn.height.toString() : '');
            setColour(selectedNurseJosn.colour);
            setBankAccount(selectedNurseJosn.bank_account);
            setNotes(selectedNurseJosn.notes);
            setDOB(GetDayJSValueFromUTCDate(selectedNurseJosn.dob));

            const tempReligions = homeState.religions.filter(col => col.id === selectedNurseJosn.religion_id);
            if (tempReligions.length > 0) {
                setSelectedReligion(tempReligions[0]);
            } else {
                setSelectedReligion(null);
            }

            if (GenderList[1].id === selectedNurseJosn.gender) {
                setSelectedGender(GenderList[1]);
            } else if (GenderList[0].id === selectedNurseJosn.gender) {
                setSelectedGender(GenderList[0]);
            }
        }
    }, [selectedNurseJosn, formOpenMode]);

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    useEffect(() => {
        let tempAge = 0;
        if (dob) {
            tempAge = dayjs().year() - dob.year();
        }
        setAge(tempAge);
    }, [dob]);

    useEffect(() => {
        handleFormValueChange();

        if (aadharUploadedDoc) {
            setAadhaar(aadharUploadedDoc.no);
        } else {
            setAadhaar('');
        }
    }, [selectedGender, selectedReligion, colour, spouseName, fatherName, motherName, aadharUploadedDoc,
        policeStation, education, languagesKnown, notes, bankAccount, height
    ]);

    const handleFormValueChange = () => {
        try {
            const tempNurse = { ...nurseFormValue };

            tempNurse.dob = dob;
            tempNurse.colour = colour.trim();
            tempNurse.spouseName = spouseName.trim();
            tempNurse.fatherName = fatherName.trim();
            tempNurse.motherName = motherName.trim();
            tempNurse.policeStation = policeStation.trim();
            tempNurse.education = education.trim();
            tempNurse.languagesKnown = languagesKnown.trim();
            tempNurse.bankAccount = bankAccount.trim();
            tempNurse.notes = notes.trim();
            tempNurse.height = height.trim();
            tempNurse.aadhaarNo = aadhaar.trim();
            tempNurse.aadhaarDocument = aadharUploadedDoc;

            tempNurse.genderId = selectedGender && selectedGender.id ? selectedGender.id : 0;
            tempNurse.religionId = selectedReligion && selectedReligion.id ? selectedReligion.id : 0;

            SetNurseFormValue(tempNurse);
        }
        catch (error) {
            OpenErrorAlert(error);
        }
    }

    const handleOpenAadharUploadClick = () => {
        setIsAadharDocForm(true);
    }

    const handleAadharDocCancelClick = () => {
        setIsAadharDocForm(false);
    }

    const handleAadharDocSaveClick = (aadharDoc) => {
        if (aadharDoc && aadharDoc.uploadedFile) {
            const documentId = aadharDoc.id;
            setAadharUploadedDoc({ ...aadharDoc, id: -100, documentId: documentId });
        }
        setIsAadharDocForm(false);
    }

    return (

        <Accordion expanded={expanded === 'panelPersonalInfo'} onChange={handleAccordionChange('panelPersonalInfo')}>
            <AccordionSummary id="panel-personal-info">
                <Typography>Personal Info</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack spacing={2}>
                    <Grid container spacing={1}>
                        <Grid size={2}>
                            <DatePicker readOnly={formOpenMode === FormMode.ViewMode} format="DD/MM/YYYY"
                                label="DOB" maxDate={dayjs().add(-18, 'year')} minDate={dayjs().add(-80, 'year')}
                                value={dob}
                                onChange={(newValue) => { setDOB(newValue); }}
                                slotProps={{
                                    textField: {
                                        size: "small", fullWidth: true, required: true,
                                        error: isShowValidationMsgs && !dob ? true : false,
                                        helperText: isShowValidationMsgs && !dob ? 'Enter DOB' : 'DD/MM/YYYY'
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => setCleared(true)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth label="Age" type="number" value={age}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <Autocomplete readOnly={formOpenMode === FormMode.ViewMode}
                                id="combo-box-gender" disableClearable
                                options={GenderList} value={selectedGender}
                                getOptionLabel={(option) => option.label}
                                onChange={(event, newValue) => {
                                    setSelectedGender(newValue);
                                }}
                                renderInput={(params) =>
                                    <TextField {...params} label="Gender" size="small" fullWidth required
                                        error={isShowValidationMsgs && !selectedGender ? true : false}
                                        helperText={isShowValidationMsgs && !selectedGender ? 'Select gender' : ''} />}
                            />
                        </Grid>
                        <Grid size={2}>
                            <Autocomplete readOnly={formOpenMode === FormMode.ViewMode}
                                id="combo-box-religion"
                                options={homeState.religions}
                                value={selectedReligion}
                                getOptionLabel={(option) => option.religion_name}
                                onChange={(event, newValue) => {
                                    setSelectedReligion(newValue);
                                }}
                                renderInput={(params) =>
                                    <TextField {...params} label="Religion" size="small" fullWidth required
                                        error={isShowValidationMsgs && !selectedReligion ? true : false}
                                        helperText={isShowValidationMsgs && !selectedReligion ? 'Select religion' : ''}
                                    />}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Height"
                                value={height}
                                onChange={(event) => {
                                    setHeight(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField size="small" fullWidth
                                label="Colour"
                                value={colour}
                                onChange={(event) => {
                                    setColour(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Spouse Name"
                                value={spouseName}
                                onChange={(event) => {
                                    setSpouseName(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Father Name"
                                value={fatherName}
                                onChange={(event) => {
                                    setFatherName(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Mother Name"
                                value={motherName}
                                onChange={(event) => {
                                    setMotherName(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>

                    {/*  <Grid container spacing={1}>
                        
                        <Grid size={6}>
                            <Stack direction="row" spacing={1}>
                                <TextField size="small" fullWidth
                                    label="Aadhaar No"
                                    value={aadhaar}
                                    slotProps={{
                                        input: {
                                            readOnly: true
                                        },
                                        htmlInput: {
                                            maxlength: 20
                                        }
                                    }}
                                />

                                {
                                    formOpenMode !== FormMode.ViewMode && !aadharUploadedDoc &&
                                    <IconButton onClick={handleOpenAadharUploadClick}>
                                        <FilePresentIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                {
                                    isAadharDocForm &&
                                    <DocumentForm isOpen={isAadharDocForm} isProfilePhoto={false} isAadhaarDoc={true} loggedUser={homeState.loggedUser}
                                        handleSaveClick={handleAadharDocSaveClick}
                                        handleCancelClick={handleAadharDocCancelClick}
                                        showAPIError={ShowAPIError} openErrorAlert={OpenErrorAlert} />
                                }
                            </Stack>

                        </Grid>
                    </Grid> */}
                    <Grid container spacing={1}>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Police Station"
                                value={policeStation}
                                onChange={(event) => {
                                    setPoliceStation(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Education"
                                value={education}
                                onChange={(event) => {
                                    setEducation(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Languages Known"
                                value={languagesKnown}
                                onChange={(event) => {
                                    setLanguagesKnown(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid size={6}>
                            <TextField size="small" fullWidth multiline
                                label="Bank Account"
                                helperText=""
                                rows={5}
                                value={bankAccount}
                                onChange={(event) => {
                                    setBankAccount(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField size="small" fullWidth multiline
                                label="Notes"
                                helperText=""
                                rows={5}
                                value={notes}
                                onChange={(event) => {
                                    setNotes(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid size={6}>
                            <NurseAddress panelId="nurse-address1-panel-content" headerText="Address 1" isShowValidationMsgs={isShowValidationMsgs}
                                formOpenMode={formOpenMode}
                            />
                        </Grid>
                        <Grid size={6}>
                            <NurseAddress panelId="nurse-address2-panel-content" headerText="Address 2" isShowValidationMsgs={false} formOpenMode={formOpenMode}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </AccordionDetails>
        </Accordion>

    );
}

export default NursePersonalnfo;
